module.exports = __webpack_public_path__ + "img/SAS Knowledge Today_Silicon Stone Education_20200905.0ece138f.jpg";